import { render } from "./AutoVision2.vue?vue&type=template&id=73641000&scoped=true"
import script from "./AutoVision2.vue?vue&type=script&lang=js"
export * from "./AutoVision2.vue?vue&type=script&lang=js"

import "./AutoVision2.vue?vue&type=style&index=0&id=73641000&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73641000"]])

export default __exports__